var s = Object.defineProperty;
var m = (a, o, t) => o in a ? s(a, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[o] = t;
var e = (a, o, t) => m(a, typeof o != "symbol" ? o + "" : o, t);
import { BaseEnvironment as i } from "./main6.js";
class p extends i {
  constructor() {
    super(...arguments);
    /**
     * Webmotors base domain
     *
     */
    e(this, "domain", "azulportal.webmotors.com.br");
    /**
     * Enable logging for BLUE Environment
     *
     */
    e(this, "logging", !0);
    /**
     * Webmotors api URL
     *
     */
    e(this, "apiURL", `https://${this.domain}/api`);
    /**
     * Webmotors base URL
     *
     */
    e(this, "baseURL", `https://${this.domain}`);
    /**
     * Webmotors private api URL
     *
     */
    e(this, "apiPrivateURL", "https://yur5i9svf7-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/azl/api");
    /**
     * SEO private api URL
     *
     */
    e(this, "seoApiPrivateURL", "https://sem3hlobfi-vpce-0f91c6824aa2e651d.execute-api.us-east-1.amazonaws.com/azl/api");
    /**
     * Cookie domain on BLUE environment
     *
     */
    e(this, "cookieDomain", [this.domain, `.${this.domain}`, ".webmotors.com.br"]);
    /**
     * Auth Cookie Name on blue environment
     *
     */
    e(this, "authCookieName", "webmotors.jwt.token");
    /**
     * Access Token Cookie Name on blue environment
     *
     */
    e(this, "accessTokenCookieName", "webmotors.access.token");
    /**
     * Refresh Token Cookie Name on blue environment
     *
     */
    e(this, "refreshTokenCookieName", "webmotors.refresh.token");
    /**
     * Vehicle photo path on BLUE environment
     *
     */
    e(this, "photoPath", "https://image.webmotors.com.br");
    /**
     * Webmotors chat api websocket URL
     *
     */
    e(this, "chatApiUrl", "wss://chat.webmotors.com.br");
    /**
     * Adobe SDK path
     *
     */
    e(this, "adobeSDK", "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-7deede3856c6-staging.min.js");
    /**
     * Hot deal image path on BLUE environment
     *
     */
    e(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/prd/_portal/");
    /**
     * Data Dog Sample Config
     */
    e(this, "traceSampleRate", 100);
    e(this, "sessionSampleRate", 10);
    e(this, "sessionReplaySampleRate", 10);
    /**
     * Seller shield image path
     */
    e(this, "sellerShieldImage", "https://azulportal.webmotors.com.br/img/blindagem/");
    /**
     * Login route
     *
     */
    e(this, "loginRoute", `https://${this.domain}/login`);
  }
}
export {
  p as BlueEnvironment
};
